import React, {useEffect} from 'react';
import {useStateWithCustomComparer} from './use-state-with-custom-comparer';
import {objectShallowEqual} from '@wix/devzai-utils-common';
import {DomEventListener, LayoutTracker} from '@wix/devzai-utils-dom';

export function useViewportBinding(scrollViewElementRef: React.RefObject<HTMLElement>) {
    const [viewportInfo, setScrollSize] = useStateWithCustomComparer(
        {
            scrollWidth: 0,
            scrollHeight: 0,
            scrollTop: 0,
            scrollLeft: 0,
            width: 0,
            height: 0
        },
        objectShallowEqual
    );

    useEffect(() => {
        const scrollViewElement = scrollViewElementRef.current!;

        const layoutTracker = new LayoutTracker(
            () => ({
                scrollWidth: scrollViewElement.scrollWidth,
                scrollHeight: scrollViewElement.scrollHeight,
                scrollLeft: scrollViewElement.scrollLeft,
                scrollTop: scrollViewElement.scrollTop,
                width: scrollViewElement.offsetWidth,
                height: scrollViewElement.offsetHeight
            }),
            {
                equalityComparer: objectShallowEqual,
                valueChangeCallback: value => {
                    setScrollSize(value);
                }
            }
        ).activate();

        const domEventListener = new DomEventListener(scrollViewElement, 'scroll', () => {
            layoutTracker.testValue();
        }).activate();

        return () => {
            layoutTracker.deactivate();
            domEventListener.deactivate();
        };
    }, []);

    return viewportInfo;
}
